import React from 'react'
import { ColumnParent, Column } from 'components/layout'
import AppContainer from './app-container'
import inlineStyles from 'styles/inline.css.js'
import Form from 'components/form/form'
import Input from 'components/input/input'
import debounce from 'lodash.debounce'
import AnimatedNumber from 'react-animated-number'
import styled, { css } from 'styled-components'

import { forecastTypes } from 'state/constants'

import { WealthBreakdownContainer } from 'sections/wealth-breakdown'
import { RetirementChartContainer } from 'sections/retirement-chart'
import SensitivityTable from 'sections/sensitivity-table/sensitivity-table'
import { formatValue } from 'state/utils'


class RetirementCalculator extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      input: {
        //questions
        forecast: '',

        //Target for Retirement
        retirement_age_target: 50,
        annual_income: 150000,
        contributions_at: 339569.83,

        //Assumptions/Inputs
        current_age: 38,
        life_expectancy: 90,
        inflation: 3,
        portfolio_return_accu: 5,
        portfolio_return_dist: 3,

        //Pension Savings(Pre-tax)  
        inv_wealth_pt: 700000, 
        pretax_contribution: 200000,
        cont_growth_pt: 0,
        tax_dist_pt: 45,

        //Non-pension savings (After-tax)
        inv_wealth_at: 150000,
        cont_growth_at: 5,
        agg_tax_type: 'Deferred',
        agg_tax: 23,

        //No Longer Used
        //leftover_assets_real
        //dist_growth
        //max_bal
        //tax_portfolio_at
        //tax_dist_at
        //tax_portfolio_pt
      },
      chartData: [],
      error: '',
      dropdownData: {},
      forecast: [],
      return_and_tax: [],
      agg_tax_type: [],
      isValidated: false,
      summaryTitle: '',
      //SummaryValueOld is used for initial value for  the number animation
      summaryValueOld: 0,
      summaryValue: 0,
    }
    this.changeGlobalState = this.changeGlobalState.bind(this)
    this.getOutput = debounce(this.getOutput.bind(this), 500)
    this.props.getRCLookupData() 
    //this.props.getUserData()
  }

  componentWillReceiveProps(nextProps){
    if(this.props.forecast !== nextProps.forecast){
      this.setState({
        forecast: nextProps.forecast,
        return_and_tax: nextProps.return_and_tax,
        agg_tax_type: nextProps.agg_tax_type,
      })
    }

    if(this.props.output !== nextProps.output){
        this.setState({
            chartData: nextProps.chartData,
            error: '',
        })
    }

    if(this.props.userData !== nextProps.userData){
      var userData = nextProps.userData
      var currentInput = this.state.input
      Object.keys(userData).map(field => {
        if(currentInput[field] !== undefined){
          if(field == 'forecast'){
            this.state.forecast.map(forecast => {
              if(forecast.key == userData[field])
                currentInput[field] = forecast.forecast
            })
          }else if(field == 'agg_tax_type'){
            this.state.agg_tax_type.map(type => {
              if(type.key == userData[field])
                currentInput[field] = type.value
            })
          }else{
            currentInput[field] = userData[field]
          }
        }
      })
      this.getOutput()      
      if(nextProps.userData.status == 401){
        this.setState({
          isValidated: false
        })
      }else{
        this.setState({
          isValidated: true
        })
      }
    }

    if(this.props.input['forecast'] !== nextProps.input['forecast']){
      var sumTitle = nextProps.input['forecast']
      var sumValOld = this.state.summaryValue
      var sumVal = 0
      switch (sumTitle) {
        case 'Retirement age': {
          sumVal = nextProps.retirementAge
          break
        }
        case 'Annual income after retirement': {
          sumVal = nextProps.retirementAnnualIncome
          break
        }
        case 'After-tax savings per annum': {
          sumVal = nextProps.afterTaxContributions
          break
        }
      }
      this.setState({
        summaryTitle: sumTitle,
        summaryValueOld: sumValOld,
        summaryValue: sumVal
      })
    }else{
      var sumTitle = nextProps.input['forecast']
      var sumValOld = 0
      var sumVal = 0
      switch (sumTitle) {
        case 'Retirement age': {
          sumValOld = this.props.retirementAge
          sumVal = nextProps.retirementAge
          if(nextProps.retirementAge > this.state.input['life_expectancy'])
            this.props.raiseError()
          break
        }
        case 'Annual income after retirement': {
          sumValOld = this.props.retirementAnnualIncome
          sumVal = nextProps.retirementAnnualIncome
          break
        }
        case 'After-tax savings per annum': {
          sumValOld = this.props.afterTaxContributions
          sumVal = nextProps.afterTaxContributions
          break
        }
      }
      this.setState({
        summaryTitle: sumTitle,
        summaryValueOld: sumValOld,
        summaryValue: sumVal
      })
    }
  }
  changeGlobalState(name, value,error) {
    this.setState((prevState, props) => {
      const input = { ...prevState.input }
      input[name] = value
      return { ...prevState, input}
    }, () => {
      this.getOutput()
    })
  }

  getOutput(){
    var hasEmptyField = false
    var isValid = true
    Object.keys(this.state.input).map(field => {
      if(this.state.input[field] === ""){
        hasEmptyField = true
      }
    })

    this.props.changeInput(this.state.input)
    if(this.state.input['forecast'] == "Annual Income" || this.state.input['forecast'] == "After-tax contributions"){
      if(this.state.input['life_expectancy'] < this.state.input['retirement_age_target']){
        isValid = false
        this.props.raiseError()
      }
    }
    
    if(this.state.input['life_expectancy'] < this.state.input['current_age']){
      isValid = false
      this.props.raiseError()
    }

    if(!hasEmptyField && isValid){
      var newInput = {...this.state.input}
      Object.keys(this.state.forecast).map(option => {
        if(newInput['forecast'] == this.state.forecast[option].forecast){
          newInput['forecast'] = this.state.forecast[option].key
        }
      })
      Object.keys(this.state.agg_tax_type).map(option => {
        if(newInput['agg_tax_type'] == this.state.agg_tax_type[option].value){
          newInput['agg_tax_type'] = this.state.agg_tax_type[option].key
        }
      })

      var percentFields = ['inflation','portfolio_return_accu','portfolio_return_dist','cont_growth_pt','tax_dist_pt','cont_growth_at','agg_tax']
      Object.keys(newInput).map(field =>{
        if(percentFields.includes(field)){
          newInput[field] = parseFloat(newInput[field]/100)
        }
      })

      this.props.getOutput(newInput)
    }
  }

  setUserRcData(){
    var newInput = {...this.state.input}
    Object.keys(this.state.forecast).map(option => {
      if(newInput['forecast'] == this.state.forecast[option].forecast){
        newInput['forecast'] = this.state.forecast[option].key
      }
    })
    Object.keys(this.state.agg_tax_type).map(option => {
      if(newInput['agg_tax_type'] == this.state.agg_tax_type[option].value){
        newInput['agg_tax_type'] = this.state.agg_tax_type[option].key
      }
    })
    this.props.setUserRcData(newInput)
  }
  render(){
    var forecastDetails = [
      {forecast: "Retirement age", detail: "Target for retirement age"},
      {forecast: "Annual income after retirement", detail: "Target annual income from portfolio after retirement in today's purchasing power"},
      {forecast: "After-tax savings per annum", detail: "Calculates required starting amount of annual after-tax contributions to portfolio during savings phase given desired retirement age and desired level of annual income upon retirement"}
    ]

    var currentUrl = new URL(window.location.href);
    var mioAccessToken = currentUrl.searchParams.get("mioBSAAccessToken");
    const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
    if (!(mioAccessToken && jwtRegex.test(mioAccessToken))) {
        return (
            <div style={inlineStyles.container}>
            <h1>401: Unauthorized</h1>
            <p>You are not authorized to access this resource.</p>
            </div>
        );
    }

    var detail = ""
    Object.keys(forecastDetails).map(option => {
      if(forecastDetails[option].forecast == this.state.input['forecast']){
        detail = forecastDetails[option].detail
      }
    })

    //console.log("this.props.chartData.length == 0",this.props.chartData.length == 0)
    return(
      <RetirementCalculatorMain>
        
        <RetirementCalculator__heading>
          <RetirementCalculator__heading_forecast_select>
            <div>
              <p>I want to calculate...</p>
              <Input type="radioButton" options={this.state.forecast} changeGlobalState={this.changeGlobalState} selectedOption={this.state.input['forecast']}/>
            </div>
            <Forecast__detail>
              <p>{detail}</p>
            </Forecast__detail>
            {this.state.isValidated ?
              <RetirementCalculator__save><div onClick={() => {this.setUserRcData()}}>Save to your profile</div></RetirementCalculator__save>
              : <div />
            }
          </RetirementCalculator__heading_forecast_select>

          <RetirementCalculator__heading_forecast_summary summary_hidden={this.props.chartData.length == 0}>
          <SummaryTitle>{this.state.summaryTitle}</SummaryTitle>
            <AnimatedNumber component="text" 
              value={this.state.summaryValue}
              initialValue={this.state.summaryValueOld}
              style={{
                  transition: '2s ease-out',
                  fontSize: 48,
              }}
              duration={500}
              formatValue={n => formatValue(n)}
              stepPrecision={2}
              />
          </RetirementCalculator__heading_forecast_summary>
        </RetirementCalculator__heading>

        <RetirementCalculator__Container>
          <RetirementCalculator__input>
            <RetirementCalculator__form>
              <Form changeGlobalState={this.changeGlobalState} forecast={this.state.input.forecast} input={this.state.input} error={this.state.error} aggregateTaxType={this.state.agg_tax_type}/>
            </RetirementCalculator__form>
          </RetirementCalculator__input>

          <RetirementCalculator__output output_hidden={this.props.chartData.length == 0}>
            <RetirementChartContainer />
            <WealthBreakdownContainer />
            <SensitivityTable sensitivityData={this.props.sensitivityData}/>
          </RetirementCalculator__output>

        </RetirementCalculator__Container>
      </RetirementCalculatorMain>
    )
  }
} 

export default AppContainer(RetirementCalculator)

const RetirementCalculatorMain = styled.div`
  font-family: 'Roboto';
  max-width: 1400px;
  margin: 0 auto;
`

const Forecast__detail = styled.div`
  height: 100%;
  width: 45%;
  padding-top: 35px;
  flex-direction: column;
  font-weight: 300;
`

const RetirementCalculator__heading = styled.div`
  display: flex;
  align-items: center;
  min-height: 120px;
`

const RetirementCalculator__heading_forecast_select = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
`

const RetirementCalculator__heading_forecast_summary = styled.div`
  flex: 0 0 600px;
  padding-left: 50px;

  ${props => props.summary_hidden && css`
    flex: 0 0 600px;
    visibility: hidden;
  `}
`

const RetirementCalculator__output = styled.div`
  position: relative;
  flex: 0 0 600px;
  padding-left: 50px;

  ${props => props.output_hidden && css`
    flex: 0 0 600px;
    visibility: hidden;
  `}
`

const RetirementCalculator__Container = styled.div`
  position: relative;
  padding-bottom: 100px;
  display: flex;
  flex-grow: 1;
`

const RetirementCalculator__form = styled.div`
  flex-grow: 1;
`

const RetirementCalculator__input = styled.div`
  display:flex;
  flex: 1;
  background: #FFF;
  box-shadow: 0px 3px 30px 0px rgba(0,0,0,0.1);
`

const RetirementCalculator__save = styled.div`
  flex-grow: 1;
  flex-direction: column;
  padding-top: 35px;

  div{
    float: right;
    position: relative;
    color: white;
    background: #DA5000;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 2px;
  }
`

const SummaryTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: #444;
`


// WEBPACK FOOTER //
// ./modules/retirement-calculator/retirement-calculator.js